// extracted by mini-css-extract-plugin
export default {"messageTemplatePreviewContainer":"message-template-preview-container__message-template-preview-container__RTNNm"};